/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $IdentifierWrapper = {
    type: 'string',
} as const;
